import { api_configuration } from "../../common";
import api_cs = api_configuration.types.client_state.alan_api;
import api_app = api_configuration.libraries.gui_definition_lib.libraries.model_lib.types.application.alan_api;
import api_gui = api_configuration.libraries.gui_definition_lib.types.gui_model.alan_api;
import { getGuiText, getGuiFile } from "../guiModel";

export function getTextValidationPattern(text_property: api_cs.Ctext__type__property) {
	return getGuiText(text_property.inferences.text_type())?.properties.validation.switch({
		none: () => undefined as api_app.Cui_text_validation | api_gui.Ctext_validation | undefined,
		custom: (custom) => custom.properties.rules,
		model: (model) => model.inferences.text_with_validation().properties.rules,
	});
}

export function getFileExtensionValidationPattern(
	property: api_cs.Cfile__type__property
): api_gui.Ctext_validation | undefined {
	return getGuiFile(property.inferences.file_type())?.properties.has_extension_validation.switch({
		no: () => undefined,
		yes: ($) => $.properties.rules,
	});
}

export function validateText(
	value: string,
	text_validation: api_app.Cui_text_validation | api_gui.Ctext_validation
): boolean {
	let regexp;
	try {
		regexp = new RegExp(`^${text_validation.properties.regular_expression}$`);
	} catch (e) {
		console.warn(
			`Invalid model regular expression: "${text_validation.properties.regular_expression}" in ${text_validation.path}`
		);
		return true;
	}
	if (regexp.test(value)) {
		return true;
	} else {
		return false;
	}
}
